import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";
import "./hm-theme.css";

const CreateCategories = ({ isOpen, onRequestClose, categoryId }) => {
  const navigate = useNavigate();
  const createUrl = "/api/testcategory/create";
  const updateUrl = `/api/testcategory/update`;
  const getCategoryUrl = `/api/testcategory/${categoryId}`;

  const [admin, setAdmin] = useState({
    categoryname: "",
    description: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (categoryId) {
      const fetchCategory = async () => {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("data")).token;
        try {
          const response = await axios.get(getCategoryUrl, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setAdmin({
            categoryname: response.data.categoryname || "",
            description: response.data.description || "",
          });
        } catch (error) {
          handleError(error);
        } finally {
          setLoading(false);
        }
      };
      fetchCategory();
    }
  }, [categoryId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

    if (admin.categoryname) {
      const url = categoryId ? updateUrl : createUrl;
      const data = {
        categoryname: admin.categoryname,
        description: admin.description,
        ...(categoryId && { id: categoryId }),
      };

      axios({
        method: "post",
        url: url,
        data: data,
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(() => {
          setLoading(false);
          onRequestClose();
          setAdmin({ categoryname: "", description: "" });
          toast.success(categoryId ? "Category Updated Successfully" : "Category Added Successfully");
        })
        .catch((error) => {
          setLoading(false);
          handleError(error);
        });
    } else {
      setLoading(false);
      toast.error("Please fill out all the required fields.");
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  function rhandle(e) {
    const { id, value } = e.target;
    setAdmin((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">category</i>
          {categoryId ? "Update Test Category" : "Add Test Category"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="categoryname" className="form-label small fw-semibold">
              Category Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="categoryname"
              type="text"
              placeholder="e.g. Hematology, Cardiology"
              value={admin.categoryname}
              onChange={rhandle}
              required
            />
          </div>

          <div className="mb-4">
            <label htmlFor="description" className="form-label small fw-semibold">
              Description
            </label>
            <textarea
              className="form-control"
              id="description"
              placeholder="Brief description of the test category..."
              value={admin.description}
              onChange={rhandle}
              rows="3"
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>save</i>
              {categoryId ? "Update Category" : "Save Category"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateCategories;
